<h1 mat-dialog-title>Success</h1>
<mat-dialog-content>
    <p>Your information has been submitted successfully!</p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-dialog-close mat-button>Close</button>
</mat-dialog-actions>
